import type { DisplayFilters } from '@wix/component-protocol/schema';

type DisplayFilter = DisplayFilters[keyof DisplayFilters];

export function applyDisplayFilter<T extends Record<string, unknown>>(
  items: T,
  filter: DisplayFilter | undefined,
): T {
  if (!filter) {
    return items;
  }

  return Object.fromEntries(
    Object.entries(items).filter(([key]) => {
      if ('show' in filter && filter.show) {
        return filter.show.includes(key);
      }

      if ('hide' in filter && filter.hide && filter.hide.includes(key)) {
        return false;
      }

      return true;
    }),
  ) as T;
}
